<template>
    <div class="home">
        <b-container fluid>
            <h1 class="mb-3">Certified Birth Certificate</h1>
            <b-row>
                <b-col>
                    <router-link to="/birth-select">
                        <b-button variant="secondary">
                            <b-icon-box-arrow-in-left/>Return to Birth Product Selection
                        </b-button>
                    </router-link>
                </b-col>
            </b-row>
            <b-row class="m-4">
                <b-col>
                    Because some vital records are confidential and some documents have restricted access, you may need to prove your identity and eligibility. The product you selected requires you to submit a notarized identity verification form before you can complete your order. Some relationships, as noted, may also require you to submit other documentation.
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <Questionnaire :product="{category:'BIRTH', name: 'Certified Birth Certificate', code: this.$route.name}"
                                   v-on:send-emit="$emit('cart-update')" v-on:order-emit="$emit('update-order')"/>
                </b-col>
            </b-row>

        </b-container>
    </div>
</template>

<script>
import Questionnaire from "@/views/product/Questionnaire";

export default {
    components: {
        Questionnaire,
    },

    data: () => ({
    }),

    computed: {
    },

    mounted() {
      document.getElementById('main-content').scrollIntoView();
    },

    methods: {
    },
    created() {
      document.title = "Certified Birth Certificate - Online Storefront"
    },

}
</script>

<style>
 .green-header {
     color: #60A609;
 }
</style>
